export default "__VITE_ASSET__BhoqiU28__"